import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

//TODO: Does this file need to exist? I think its handled by GnereModal now...
@inject('genreStore')
@observer
class AddGenre extends React.Component {
	constructor (props) {
		super(props);
		this.state = {
			showForm: false,
			newGenres: ''
		};
	}

	render () {
		return (
			<div className="add-genre-container">
				<button className="add-button button" onClick={ this.onAddClick }>
					<span className="fas fa-plus"></span> Add Genre
				</button>

				{ this.renderForm() }
			</div>
		);
	}

	renderForm () {
		if (this.state.showForm !== true) {

			return null;
		}

		return (
			<div className="grid-8 grid-padding-8 align-bottom add-genre-form">
				<div className="cell">
					<label>Enter 1 or more genres, each on their own line</label>
				</div>
				<div className="cell">
					<textarea onChange={ this.onChange }>
						{ this.state.newGenres }
					</textarea>
				</div>
				<div className="cell">
					<button className="button clear" onClick={ this.onSaveClick }>Save</button>
					<button className="button clear" onClick={ this.onCancelClick }>Cancel</button>
				</div>
			</div>
		);
	}

	@autobind
	onAddClick () {
		this.setState({
			showForm: true
		});
	}

	@autobind
	onCancelClick () {
		this.setState({
			showForm: false
		});
	}

	@autobind
	onSaveClick () {
		const { genreStore } = this.props;
		const { newGenres = '' } = this.state;
		const genreList = _.compact(newGenres.split('\n')).map((label) => ({ label }));

		genreStore.addGenres(genreList);

		this.setState({
			showForm: false,
			newGenres: ''
		});
	}

	@autobind
	onChange ({ target }) {
		this.setState({
			newGenres: target.value
		});
	}
}

export default AddGenre;
